/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { GeneralRestApiOptions } from './types';

export const createGeneralEnterprisesRepository = (
    options: GeneralRestApiOptions
): Types.GeneralEnterprisesRepository => ({
    async addSample(params, requestOptions) {
        return options.request('/enterprises/addSample', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getActiveResourceTiers(params, requestOptions) {
        return options.request('/enterprises/getActiveResourceTiers', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getAll(params, requestOptions) {
        return options.request('/enterprises/getAll', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
